import { matchPath } from 'react-router-dom';

/** Alvo que o servidor valida (recorte por parlamentar etc.); a rota por si só nunca autoriza nada. */
export type AlvoSolicitacao = {
  emendaId?: string;
  planoId?: string;
  preProjetoId?: string;
};

export type ContextoTela = AlvoSolicitacao & {
  /** Caminho interno + query (sem o fragmento), como o roteador enxerga. */
  rota: string;
  tituloTela: string;
};

const PADROES: Array<{ path: string; alvo: (p: Record<string, string | undefined>) => AlvoSolicitacao }> = [
  { path: '/dashboard/emendas/:id', alvo: (p) => (p.id === 'visao-geral' ? {} : { emendaId: p.id }) },
  { path: '/dashboard/plano/full/:id', alvo: (p) => ({ planoId: p.id }) },
  { path: '/dashboard/pre-projetos/:id', alvo: (p) => (p.id === 'novo' ? {} : { preProjetoId: p.id }) },
];

/** Identifica pela rota a que emenda, plano ou pré-projeto a tela se refere; telas sem alvo ficam só com rota e título. */
export function contextoDaTela(pathname: string, search: string, tituloTela: string): ContextoTela {
  let alvo: AlvoSolicitacao = {};
  for (const { path, alvo: extrair } of PADROES) {
    const m = matchPath({ path, end: true }, pathname);
    if (m) {
      alvo = extrair(m.params);
      break;
    }
  }
  return { rota: `${pathname}${search}`, tituloTela, ...alvo };
}
